import React, { useState, useEffect } from 'react'
import { Card, Modal, Tooltip } from 'antd'
import dayjs from 'dayjs'
import {
  getListApiStatusDashboardRfid,
  // queryLastUpdateTimeRfid,
  channelMachineStatusSevenDataRfid
} from '@/services/rfid/rfidDashboard/rfidDashboard'
import AntdTable from '@/components/table/AntdTable'
import { formatMessageNew, numFormat } from '@/utils/common'
import RFIDTunnelModalTable from '@/pages/rfid/rfidDashboard/components/RFIDTunnelModalTable'
import RFIDApiModalTable from '@/pages/rfid/rfidDashboard/components/RFIDApiModalTable'

const dateFormat = 'YYYY-MM-DD'
const dateFormat2 = 'MM/DD/YYYY HH:mm:ss'
const startMonth = dayjs().subtract(6, 'day')
const endMonth = dayjs()

const RFIDDashboard = () => {
  const [tableList, setTableList] = useState([])
  const [tableListStore, setTableListStore] = useState([])
  const [pageTime, setPageTime] = useState('')
  const [modalVisible, setModalVisible] = useState(false)
  const [apiModalVisible, setApiModalVisible] = useState(false)
  const [selectItem, setSelectItem] = useState({})

  useEffect(() => {
    setPageTime(dayjs().format(dateFormat2))
    searchDataFun()
    getApiStatusDashboardFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const searchDataFun = () => {
    // queryLastUpdateTimeRfid({}).then(res => {
    //   setPageTime(res.resultData)
    // })
    let params = {
      endTime: endMonth.format(dateFormat),
      startTime: startMonth.format(dateFormat),
      tunnelMachines: []
    }
    channelMachineStatusSevenDataRfid(params).then(res => {
      if (res.resultData) {
        setTableList(res.resultData || [])
      }
    })
  }
  const getApiStatusDashboardFun = () => {
    getListApiStatusDashboardRfid({}).then(res => {
      setTableListStore(res.resultData || [])
    })
  }

  const tableItemClick = record => {
    setSelectItem(record)
    setModalVisible(true)
  }
  const apiTableItemClick = record => {
    setSelectItem(record)
    setApiModalVisible(true)
  }

  const handleModalCancel = () => {
    setModalVisible(false)
    setApiModalVisible(false)
  }

  const tableColumns = [
    {
      title: formatMessageNew('languageObj.rfidDashboard.tunnelMachine'),
      width: 100,
      dataIndex: 'tunnelMachine'
    },
    {
      title: formatMessageNew('languageObj.rfidDashboard.status'),
      width: 100,
      dataIndex: 'status',
      ellipsis: {
        showTitle: false
      },
      render: (text, record) => {
        return (
          <Tooltip placement="topLeft" title={<div className="word_break_all">{text}</div>}>
            <div
              onClick={() => {
                tableItemClick(record)
              }}
              className={
                record.statusCode === 101 || record.statusCode === 102 || record.statusCode === 103
                  ? 'overflowDot link_name_dashboard link_name_dashboard_error'
                  : 'overflowDot link_name_dashboard link_name_dashboard_info'
              }
            >
              {text}
            </div>
          </Tooltip>
        )
      }
    },
    {
      title: formatMessageNew('languageObj.rfidDashboard.updateTime'),
      width: 100,
      dataIndex: 'lastUpdatedTime'
    }
  ]
  const tableColumnsStore = [
    {
      title: formatMessageNew('languageObj.rfidDashboard.apiType'),
      width: 100,
      dataIndex: 'apiType',
      ellipsis: {
        showTitle: false
      },
      render: text => {
        return (
          <Tooltip placement="topLeft" title={<div className="word_break_all">{text}</div>}>
            {text}
          </Tooltip>
        )
      }
    },
    {
      title: formatMessageNew('languageObj.rfidDashboard.failCount'),
      width: 50,
      dataIndex: 'failCount',
      render: (text, record) => {
        return (
          <div
            onClick={() => {
              apiTableItemClick(record)
            }}
            className={
              text > 0
                ? 'link_name_dashboard link_name_dashboard_error'
                : 'link_name_dashboard link_name_dashboard_info'
            }
          >
            {numFormat(text)}
          </div>
        )
      }
    },
    {
      title: formatMessageNew('languageObj.rfidDashboard.store'),
      width: 120,
      ellipsis: {
        showTitle: false
      },
      dataIndex: 'storeList',
      render: text => {
        return (
          <Tooltip
            placement="topLeft"
            title={<div className="word_break_all">{text && text.filter(Boolean).join(',')}</div>}
          >
            {text && text.filter(Boolean).join(',')}
          </Tooltip>
        )
      }
    },
    {
      title: formatMessageNew('languageObj.rfidDashboard.updateTime'),
      width: 100,
      dataIndex: 'updateTime'
    }
  ]

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100%' }}>
      <div style={{ width: '70%' }}>
        <Card bordered={false} bodyStyle={{ padding: 4 }}>
          <div className="content-container">
            <div className="mb15" style={{ fontWeight: 600 }}>
              {formatMessageNew('languageObj.rfidDashboard.refreshTime')}
              {pageTime}
            </div>
            <AntdTable
              title={() => <div>{formatMessageNew('languageObj.rfidDashboard.history')}</div>}
              bordered
              dataSource={tableList}
              columns={tableColumns}
            />
          </div>
          <div className="content-container">
            <AntdTable dataSource={tableListStore} columns={tableColumnsStore} />
          </div>
        </Card>
      </div>
      <Modal
        open={modalVisible}
        maskClosable={false}
        className="nike_modal"
        width="70%"
        title={formatMessageNew('languageObj.rfidDashboard.tunnelReportTitle')}
        onCancel={handleModalCancel}
        destroyOnClose
        footer={null}
      >
        <RFIDTunnelModalTable selectItem={selectItem} />
      </Modal>
      <Modal
        open={apiModalVisible}
        maskClosable={false}
        className="nike_modal"
        width="70%"
        title={formatMessageNew('languageObj.rfidDashboard.apiReportTitle')}
        onCancel={handleModalCancel}
        destroyOnClose
        footer={null}
      >
        <RFIDApiModalTable selectItem={selectItem} />
      </Modal>
    </div>
  )
}
export default RFIDDashboard
